import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../user.model';
import { UserService } from '../user.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-user-detail-profile',
  templateUrl: './user-detail-profile.component.html',
  styleUrls: ['./user-detail-profile.component.css']
})
export class UserDetailProfileComponent implements OnInit {

  constructor(private route: ActivatedRoute, private userService: UserService, private authService: AuthService) { }

  user: User;

  async ngOnInit() {
    if (this.route.snapshot.parent.params.userId) {
      this.user = await this.userService.get(this.route.snapshot.parent.params.userId).pipe(first()).toPromise();
    } else {
      this.user = await this.authService.user$.pipe(first()).toPromise();
    }
  }

}
